import React from 'react';

export const FPMoneyfront = [
	{
		id: 2,
		type: 'multicolumn',
		paragraphs: [
			{
				id: 21,
				paragraph: [
					<p>
						There is clearly a universal need for financial planning, but
						planning ones finances on their own can be a daunting task. Not only
						can taking some financial decisions be overwhelming, the
						consequences of wrong turns can result in costly damages in the
						future. Most people end up making investment decisions based on the
						recommendations of agents and brokers who earn commissions deducted
						from the invested amount. Agents recommend schemes and policies that
						provide them with higer
					</p>,
				],
			},
			{
				id: 22,
				paragraph: [
					<p>
						commissions, rather than looking after the financial welfare of the
						investor. Since, as a financial planning company, we offer direct
						plans of mutual funds as a key investment option, our advisory is
						not biased and is instead inclined towards achieving and meeting
						investors’ financial needs and objectives. At the same time, the
						research team at Moneyfront ensures the plan created is based on
						evaluating the investors’ risk appetite, goal timelines, investment
						approach etc.
					</p>,
				],
			},
		],
	},
	{
		id: 3,
		paragraphs:
			'We also offer an automated financial planning module to our clients where they can map their goals, and invest as per their risk profiles to achieve those goals. The module also helps track the progress for each goal.',
	},
];
